module.exports = __webpack_public_path__ + "static/media/hotel6.6a43bade.jpg";